import { useEffect, useState } from "react";
import { ApiError, api } from "./client";

export type AgendaItem = {
  appointment_id: string;
  starts_at: string;
  ends_at: string;
  duration_minutes: number;
  lesson_type: "normal" | "special" | "extra" | string;
  status: "planned" | "in_progress" | "completed" | "cancelled" | string;
  conflict_accepted: boolean;
  student_id: string;
  student_name: string;
  student_phone: string | null;
  student_exam_date: string | null;
  vehicle_id: string;
  vehicle_plate: string;
  vehicle_brand_model: string | null;
  vehicle_gear_type: string | null;
  vehicle_current_km: number;
  has_report: boolean;
  report_attended: boolean | null;
  report_start_km: number | null;
  report_end_km: number | null;
  report_driving_score: number | null;
};

export type AgendaSummary = {
  total: number;
  planned: number;
  completed: number;
  pending_report: number;
  total_completed_minutes: number;
};

export type AgendaResponse = {
  items: AgendaItem[];
  summary: AgendaSummary;
  filter: { instructor_id: string; start_date: string; end_date: string };
};

export function useInstructorAgenda(startDate: string, endDate: string) {
  const [data, setData] = useState<AgendaResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError(null);
    api
      .get<AgendaResponse>(
        "/instructors/me/agenda",
        { start_date: startDate, end_date: endDate },
        { signal: controller.signal },
      )
      .then((res) => setData(res))
      .catch((err) => {
        if (controller.signal.aborted) return;
        setError(err instanceof ApiError ? err.message : "Ajanda Yüklenemedi.");
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, [startDate, endDate, reloadKey]);

  return { data, loading, error, reload: () => setReloadKey((k) => k + 1) };
}
